<template>
  <div class="document-wrapper">
    <div class="document" v-if="information">
        <b-input
        v-model='information.title'
        placeholder="Заголовок информации"/>
        <Editor
        :editorToolbar="customToolbar"
        placeholder="Текст информации"
        v-model="text"/>
        <b-field label="Дата и время публикации">
          <el-date-picker
            v-model="date"
            :editable="false"
            type="datetime"
            placeholder="Дата">
          </el-date-picker>
        </b-field>
        <span class="button is-fullwidth" @click="save">СОХРАНИТЬ</span>
        <router-link :to="{ name: 'BrokerInformation' }" class="button is-fullwidth">ОТМЕНА</router-link>
        <span class="button is-fullwidth is-danger" @click="deleteBrokerInformation(information.id)" v-if="$route.params.id">УДАЛИТЬ</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { VueEditor as Editor } from 'vue2-editor'
import deepcopy from 'deepcopy'

export default {
  name: 'BrokerInformationItem',
  data () {
    return {
      text: null,
      date: null,
      customToolbar: [
        ['bold', 'italic', 'underline', 'link']
      ]
    }
  },
  created () {
    if (this.$route.params.id) {
      this.getBrokerInformationById(this.$route.params.id)
    }
  },
  computed: {
    ...mapState(['brokerInformation']),
    information () {
      if (this.$route.params.id) {
        this.text = this.brokerInformation.text
        this.date = this.brokerInformation.date
        return deepcopy(this.brokerInformation)
      } else {
        this.date = new Date()
        return {
          date: new Date(),
          title: '',
          text: ''
        }
      }
    }
  },
  methods: {
    ...mapActions(['deleteBrokerInformation', 'updateBrokerInformation', 'getBrokerInformationById', 'addBrokerInformation']),
    save () {
      this.information.date = this.date
      this.information.text = this.text
      if (this.$route.params.id) {
        this.updateBrokerInformation(this.information)
      } else {
        this.addBrokerInformation(this.information)
      }
    }
  },
  components: { Editor }
}
</script>
<style scoped>
.document {
  padding: 25px;
  max-width: 600px;
  margin: 0 auto;
}
.document-wrapper {
  margin-bottom: 40px;
  display: block;
  height: initial;
}
.document .delete-icon {
  position: initial;
  width: 34px;
  margin-top: 0.75em;
}
.field {
  margin: 20px 0 0;
}
</style>
<style>
.quillWrapper {
  background: white;
  margin-top: 15px;
}
.information-container .ql-editor {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// BrokerInformationItem.vue?3428a0c1